<template>
  <v-dialog v-model="isOpen" width="800">
    <v-card>
      <v-card-title>
        <h2 class="heading">{{ $t('signAdvanceDialogTitle') }}</h2>
      </v-card-title>
      <v-card-text>
        <i18n path="signAdvanceDialogText" tag="p">
          <strong>{{ advance.title }}</strong>
        </i18n>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn text color="error" @click="cancel">{{ $t('Cancel') }}</v-btn>
        <v-btn data-testid="confirm-sign-button" text color="primary" @click="sign">{{ $t('signAdvanceSign') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { createLink } from '@/api/helpers'
import { api } from '@/api'
import get from 'lodash/get'

export default {
  name: 'AdvanceSignDialog',
  data() {
    return {
      isOpen: false,
      advance: {},
    }
  },
  methods: {
    async sign() {
      try {
        await api.post(createLink('/advance/{id}/sign', { id: this.advance.id }))
        this.cancel()
        this.$emit('signed')
        this.notifySuccess(this.$t('signAdvanceDialogSignSuccess'))
      } catch (error) {
        const message = get(error, 'response.data.non_field_errors', []).join(' ')
        this.notifyError(this.$t('signAdvanceDialogSignError', { message }))
      }
    },
    cancel() {
      this.advance = {}
      this.isOpen = false
    },
    open(advance) {
      this.advance = advance
      this.isOpen = true
    },
  },
}
</script>
